import { SET_SAVING, SET_ERROR, SET_CURRENCY, INIT_FORM, SET_EXCHANGE_RATE } from '@/constants/mutation_types'
import { CURRENCY_USA } from '@/constants/trans'
import { getExchangeRate } from '@/api/airticket'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    items: {
      baseCurrency: CURRENCY_USA,
      saleCurrency: CURRENCY_USA,
      exchangeRate: 7.00,
      original_fare: 0,
      total_fare: 0,
      ticket_service_fee: 0,
      mcoServiceFee: 0,
      itineraryParsed: {
        locator: '',
        invoice: '',
        ticketed_time: '',
        aircompany_code: '',
        start_date: '',
        end_date: '',
        schedules: null,
        email: '',
        phone: '',
        base_currency: '',
        sale_currency: '',
        ticket_info: null,
        issued_from: '',
        passengers_info: null
      },
      basePrice: {
        payment_method: ''
      },
      sellPrice: {
        payment_method: ''
      }
    },
    saving: false,
    errors: []
  },
  getters: {
    mcoAmount: (state) => state.items.original_fare
  },
  mutations: {
    [SET_SAVING] (state, saving) {
      state.saving = saving
    },
    [SET_ERROR] (state, errors) {
      state.errors = state.errors.concat(errors)
    },
    [SET_CURRENCY] (state, {item, currency}) {
      state.items[`${item}Currency`] = currency
    },
    [INIT_FORM] (state, itineraryParsed) {
      state.items.itineraryParsed = itineraryParsed
    },
    [SET_EXCHANGE_RATE] (state, rate) {
      state.items.exchangeRate = rate
    },
    // eslint-disable-next-line
    SET_FARE (state, {originalFare, totalFare}) {
      // eslint-disable-next-line
      state.items.original_fare = originalFare
      // eslint-disable-next-line
      state.items.total_fare = totalFare
    },
    setServiceFee (state, fee) {
      state.items.ticket_service_fee = Number(fee)
    },
    setMcoServiceFee (state, fee) {
      state.items.mcoServiceFee = Number(fee)
    },
    setSellMethod (state, method) {
      state.items.sellPrice.payment_method = method
    },
    setBaseMethod (state, method) {
      state.items.basePrice.payment_method = method
    },
    initFareState (state) {
      let init = {
        ...state.items,
        baseCurrency: CURRENCY_USA,
        saleCurrency: CURRENCY_USA,
        exchangeRate: 7.00,
        original_fare: 0,
        total_fare: 0,
        ticket_service_fee: 0,
        mcoServiceFee: 0
      }
      Vue.set(state, 'items', init)
    },
    // eslint-disable-next-line
    initUpdatePayment (state, {baseCurrency, saleCurrency, exchangeRate, original_fare, total_fare, ticket_service_fee, mco_service_fee}) {
      state.items = {
        ...state.items,
        baseCurrency,
        saleCurrency,
        exchangeRate,
        original_fare,
        total_fare,
        ticket_service_fee,
        mco_service_fee
      }
    }
  },
  actions: {
    setSaving ({ commit }, saving) {
      commit('SET_SAVING', saving)
    },
    setError ({ commit }, errors) {
      commit('SET_ERROR', errors)
    },
    setCurrency ({ commit }, {item, currency}) {
      commit('SET_CURRENCY', {item, currency})
    },
    setExchangeRate ({ commit }, exchangeRate) {
      commit('SET_EXCHANGE_RATE', exchangeRate)
    },
    setMcoServiceFee ({ state, commit }, fee) {
      commit('setMcoServiceFee', fee)
    },
    initFormFromItinerary ({ commit }, itineraryParsed) {
      commit('INIT_FORM', itineraryParsed)
    },
    fetchExchange ({ commit }, base) {
      return new Promise((resolve, reject) => {
        getExchangeRate()
          .then(resp => {
            let rate = resp.data.rates['CNY'].toFixed(2)
            if (!rate) {
              reject(new Error(`Can't get rate`))
              rate = 7.00
            }
            commit('SET_EXCHANGE_RATE', rate)
            resolve(rate)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/airticket.js